/**
 * Actions to be dispatched to update the state of the LENSE buttons and magnifications
 */

/**
 * @param {Object} data - The data for the update lense buttons and magnifications.
 * @returns {Object} - The action object with type and payload.
 */

export const setCurrentMagnification = (data) => {
  return { type: "SET_CURRENT_MAGNIFICATION", payload: data };
};

export const setDefaultMagnification = (data) => {
  return { type: "SET_DEFAULT_MAGNIFICATION", payload: data };
};

export const changeFocus = (data) => {
  return { type: "CHANGE_FOCUS", payload: data };
};

export const adjustLight = (data) => {
  return { type: "ADJUST_LIGHT", payload: data };
};

export const toggleLight = (data) => {
  return { type: "TOGGLE_LIGHT", payload: data };
};

export const changePosition = (data) => {
  return { type: "CHANGE_POSITION", payload: data };
};

export const changeViewportPosition = (data) => {
  return { type: "CHANGE_VIEWPORT_POSITION", payload: data };
};

export const changeKnob = (data) => {
  return { type: "CHANGE_KNOB", payload: data };
};

export const updateHeight = (data) => {
  return { type: "UPDATE_HEIGHT", payload: data };
};

export const updateHeightOnBiggerScreens = (data) => {
  return { type: "UPDATE_HEIGHT_ON_BIGGER_SCREENS", payload: data };
};

export const updateViewPortImage = (data) => {
  return { type: "VIEWPORT_IMAGE", payload: data };
};

export const storeResultsImage = (data) => {
  return { type: "STORE_IMAGE", payload: data };
};

export const updateMicroscopeImage = (data) => {
  return { type: "UPDATE_MICROSCOPE", payload: data };
};

export const selectThumbnail = (data) => {
  return { type: "SELECT_THUMBNAIL", payload: data };
};
